<template><div class="markdown"><html><head></head><body><dyy-anchor anchor-list="Tooltip,inputNumber,贡献者"></dyy-anchor><dyy-title title-name="Tooltip"></dyy-title><p><code v-pre="">超出外部dom宽度...时鼠标移入展示所有</code></p>
<div class="flex_col"><dyy-code><template v-slot:code="">&lt;template&gt;
  &lt;div&gt;
    &lt;div style="width: 150px"&gt;
      &lt;dyy-tooltip content="测试Tooltip宽度超过后问题" placement="top"&gt;
        &lt;span&gt;测试Tooltip宽度超过后问题测试Tooltip宽度超过后问题&lt;/span&gt;
      &lt;/dyy-tooltip&gt;
    &lt;/div&gt;
    &lt;dyy-tooltip content="测试Tooltip宽度超过后问题"&gt;
      &lt;p&gt;测试Tooltip宽度超过后问题测试Tooltip宽度超过后问题&lt;/p&gt;
    &lt;/dyy-tooltip&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {}
    }
  }
&lt;/script&gt;
</template><pre v-pre=""><code>&lt;template&gt;
  &lt;div&gt;
    &lt;div style="width: 150px"&gt;
      &lt;dyy-tooltip content="测试Tooltip宽度超过后问题" placement="top"&gt;
        &lt;span&gt;测试Tooltip宽度超过后问题测试Tooltip宽度超过后问题&lt;/span&gt;
      &lt;/dyy-tooltip&gt;
    &lt;/div&gt;
    &lt;dyy-tooltip content="测试Tooltip宽度超过后问题"&gt;
      &lt;p&gt;测试Tooltip宽度超过后问题测试Tooltip宽度超过后问题&lt;/p&gt;
    &lt;/dyy-tooltip&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {}
    }
  }
&lt;/script&gt;
</code></pre></dyy-code><template>
  <div>
    <div style="width: 150px">
      <dyy-tooltip content="测试Tooltip宽度超过后问题" placement="top">
        <span>测试Tooltip宽度超过后问题测试Tooltip宽度超过后问题</span>
      </dyy-tooltip>
    </div>
    <dyy-tooltip content="测试Tooltip宽度超过后问题">
      <p>测试Tooltip宽度超过后问题测试Tooltip宽度超过后问题</p>
    </dyy-tooltip>
  </div>
</template>

</div><dyy-title title-name="inputNumber"></dyy-title><div class="flex_col"><dyy-code><template v-slot:code="">&lt;template&gt;
  &lt;el-form :model="form" inline&gt;
    &lt;el-form-item label="数字:4位小数"&gt;
      &lt;el-input v-number-input:4 type="number" v-model="form.value" @input="handleInput"/&gt;
    &lt;/el-form-item&gt;
    &lt;el-form-item label="数字"&gt;
      &lt;el-input v-number-input type="number" v-model="form.value1" @input="handleInput1"/&gt;
    &lt;/el-form-item&gt;
&lt;el-form-item label="数字2"&gt;
      &lt;el-input v-number-input:2 type="number" v-model="form.value2" @input="handleInput1"/&gt;
    &lt;/el-form-item&gt;
    &lt;el-button @click="submit"&gt;提交&lt;/el-button&gt;
  &lt;/el-form&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        form: {
          value: 0,
          value1: 0,
          value2: 0,
        }
      }
    },
    methods: {
      submit() {
        console.log(this.form.value);
        console.log(this.form.value1)
      },
      handleInput() {
        console.log(this.form.value)
      },
      handleInput1() {
        console.log(this.form.value1)
      }
    }
  }
&lt;/script&gt;
</template><pre v-pre=""><code>&lt;template&gt;
  &lt;el-form :model="form" inline&gt;
    &lt;el-form-item label="数字:4位小数"&gt;
      &lt;el-input v-number-input:4 type="number" v-model="form.value" @input="handleInput"/&gt;
    &lt;/el-form-item&gt;
    &lt;el-form-item label="数字"&gt;
      &lt;el-input v-number-input type="number" v-model="form.value1" @input="handleInput1"/&gt;
    &lt;/el-form-item&gt;
&lt;el-form-item label="数字2"&gt;
      &lt;el-input v-number-input:2 type="number" v-model="form.value2" @input="handleInput1"/&gt;
    &lt;/el-form-item&gt;
    &lt;el-button @click="submit"&gt;提交&lt;/el-button&gt;
  &lt;/el-form&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        form: {
          value: 0,
          value1: 0,
          value2: 0,
        }
      }
    },
    methods: {
      submit() {
        console.log(this.form.value);
        console.log(this.form.value1)
      },
      handleInput() {
        console.log(this.form.value)
      },
      handleInput1() {
        console.log(this.form.value1)
      }
    }
  }
&lt;/script&gt;
</code></pre></dyy-code><template>
  <el-form :model="form" inline="">
    <el-form-item label="数字:4位小数">
      <el-input v-number-input:4="" type="number" v-model="form.value" @input="handleInput">
    </el-input></el-form-item>
    <el-form-item label="数字">
      <el-input v-number-input="" type="number" v-model="form.value1" @input="handleInput1">
    </el-input></el-form-item>
<el-form-item label="数字2">
      <el-input v-number-input:2="" type="number" v-model="form.value2" @input="handleInput1">
    </el-input></el-form-item>
    <el-button @click="submit">提交</el-button>
  </el-form>
</template>


</div><div class="flex_col"><dyy-code><template v-slot:code="">&lt;template&gt;
&lt;div&gt;
  &lt;el-button @click="login"&gt;login&lt;/el-button&gt;
&lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
export default {
  data() {
    return {}
    },
    methods: {
      login() {
        location.href="http://localhost/#/login"
      }
    }
  }
&lt;/script&gt;
</template><pre v-pre=""><code>&lt;template&gt;
&lt;div&gt;
  &lt;el-button @click="login"&gt;login&lt;/el-button&gt;
&lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
export default {
  data() {
    return {}
    },
    methods: {
      login() {
        location.href="http://localhost/#/login"
      }
    }
  }
&lt;/script&gt;
</code></pre></dyy-code><template>
<div>
  <el-button @click="login">login</el-button>
</div>
</template>

</div><dyy-title title-name="贡献者"></dyy-title><dyy-contributor contribute-list="dyyTooltip"></dyy-contributor><dyy-page></dyy-page></body></html></div></template>
<style scope="">
  /* chrome */ 
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button { 
      -webkit-appearance: none; 
  }
  /* 火狐浏览器 */
  input[type="number"]{ 
      -moz-appearance: textfield; 
  }
</style>
<script>export default { mixins: [
   {
    data() {
      return {}
    }
  }
,
   {
    data() {
      return {
        form: {
          value: 0,
          value1: 0,
          value2: 0,
        }
      }
    },
    methods: {
      submit() {
        console.log(this.form.value);
        console.log(this.form.value1)
      },
      handleInput() {
        console.log(this.form.value)
      },
      handleInput1() {
        console.log(this.form.value1)
      }
    }
  }
,
 {
  data() {
    return {}
    },
    methods: {
      login() {
        location.href="http://localhost/#/login"
      }
    }
  }
,]}</script>